/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeAblyRpc
 */

export const CompositeTargetingConfigTypename = 'com.hubspot.personalize.models.CompositeTargetingConfig';
export const CompositeTargetingConfigDiscriminant = 'COMPOSITE';
export const CompositeTargetingConfigDiscriminantKey = 'type';
export const CrmObjectTargetingConfigTypename = 'com.hubspot.personalize.models.CrmObjectTargetingConfig';
export const CrmObjectTargetingConfigDiscriminant = 'CRM_OBJECT';
export const CrmObjectTargetingConfigDiscriminantKey = 'type';
export const SegmentTargetingConfigTypename = 'com.hubspot.personalize.models.SegmentTargetingConfig';
export const SegmentTargetingConfigDiscriminant = 'SEGMENT';
export const SegmentTargetingConfigDiscriminantKey = 'type';
export const TargetingConfigDiscriminantKey = 'type';
export const getAblyTokenRequestRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeAblyRpc',
  rpcName: 'getAblyTokenRequest',
  auth: 'app',
  fingerprint: 'hjHY7VhYgKtETNRZE1Tryw6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStrategyChannelIdRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeAblyRpc',
  rpcName: 'getStrategyChannelId',
  auth: 'app',
  fingerprint: '1a5G4RUkaJZx-J6uwjFIUg6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};